<div class="modal-header">
  <div class="header-content">
    <div class="header-icon">
      <i class="fas fa-cube"></i>
    </div>
    <div class="header-text">
      <h2>Create New Enquiry?</h2>
      <p>{{ remainingItems.length }} remaining items available</p>
    </div>
  </div>
  <button 
    type="button" 
    class="btn-close"
    aria-label="Close"
    (click)="dismiss()"
  >
  </button>
</div>

<div class="modal-body">
  <!-- Info Message -->
  <div class="info-message">
    <div class="info-icon">
      <i class="fas fa-info-circle"></i>
    </div>
    <p>Would you like to create a new enquiry for any remaining items?</p>
  </div>

  <!-- Select All Section -->
  <div class="select-all-section" *ngIf="remainingItems.length > 0">
    <button 
      type="button"
      class="select-all-btn"
      [class.all-selected]="allSelected"
      (click)="toggleSelectAll()"
    >
      <i [class]="allSelected ? 'fas fa-check-square' : 'far fa-square'"></i>
      Select All Items
    </button>
  </div>

  <!-- Items List -->
  <div class="items-list" *ngIf="remainingItems.length > 0">
    <div 
      *ngFor="let item of remainingItems; let i = index" 
      class="item-row"
      [class.selected]="item.selected"
      (click)="toggleItem(item)"
    >
      <div class="item-checkbox">
        <input 
          type="checkbox"
          class="form-check-input"
          [(ngModel)]="item.selected"
          (change)="onItemSelectionChange()"
          (click)="$event.stopPropagation()"
        />
      </div>
      
      <div class="item-content">
        <div class="item-main">
          <h4 class="part-name">{{ item.partDescription || 'Unknown Part' }}</h4>
          <div class="item-details">
            <span class="part-no">
              <i class="fas fa-barcode"></i>
              {{ item.partNo || 'No Part Number' }}
            </span>
            <span class="quantity">
              <i class="fas fa-layer-group"></i>
              Qty: {{ item.qty }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty State -->
  <div class="empty-state" *ngIf="remainingItems.length === 0">
    <div class="empty-icon">
      <i class="fas fa-check-circle"></i>
    </div>
    <h4>All Items Selected</h4>
    <p>You have already selected all available items for this order</p>
  </div>
</div>

<div class="modal-footer">
  <div class="footer-buttons">
    <button 
      type="button"
      class="btn skip-btn"
      (click)="skip()"
    >
      <i class="fas fa-times"></i>
      Skip for Now
    </button>
    
    <button 
      type="button"
      class="btn create-btn"
      (click)="confirm()"
      [disabled]="selectedCount === 0"
    >
      <i class="fas fa-plus-circle"></i>
      Create Enquiry ({{ selectedCount }})
    </button>
  </div>
</div>
